import * as React from 'react';
import { AppVoiceRecorderProps } from './AppVoiceRecorder.props';
import { AppButton } from '../AppButton';
import { getAppVoiceRecorderStyles } from './AppVoiceRecorder.styles';
import { Label, Spinner, SpinnerType } from 'office-ui-fabric-react';
import { FormatTimeDescription, FormatTime } from '../../utils';
import { AppMicWidget } from './AppMicWidget';
import { AppMicWidgetRecorderState } from './AppMicWidget/AppMicWidget.props';

interface AppVoiceRecorderState {
  isPaused: boolean;
  isRecordingCompleted: boolean;
  recordingTime: number;
}

export class AppVoiceRecorder extends React.PureComponent<AppVoiceRecorderProps, AppVoiceRecorderState> {
  private intervalID: number | null = null;

  constructor(props: AppVoiceRecorderProps) {
    super(props);

    this.state = {
      isPaused: false,
      isRecordingCompleted: false,
      recordingTime: 0
    };

    if (props.isEnabled) {
      this.StartRecordingTimer();
    }
  }

  public componentWillUnmount() {
    window.clearInterval(this.intervalID!);
  }

  public componentDidUpdate(prevProps: AppVoiceRecorderProps) {
    if (this.props.isEnabled && !prevProps.isEnabled) {
      this.StartRecordingTimer();
    }

    if (!this.props.isEnabled && prevProps.isEnabled) {
      this.StopRecordingTimer();
    }
  }

  public render() {
    const { isPaused, isRecordingCompleted, recordingTime } = this.state;
    const { recordingStatusLabel, stopRecordingButtonLabel, isEnabled } = this.props;
    const styles = getAppVoiceRecorderStyles();

    return (
      <div className={styles.root}>
        {!isRecordingCompleted ? <React.Fragment>
          <Label aria-label={FormatTimeDescription(recordingTime, true /* show seconds */)} className={styles.timer}>{FormatTime(recordingTime)}</Label>
          <div className={styles.micWidgetContainer}>
            <AppMicWidget type={'AppMicWidgetProps'} isEnabled={isEnabled} currentMicState={isPaused ? AppMicWidgetRecorderState.Paused : AppMicWidgetRecorderState.Recording} onMicWidgetClicked={this._onPauseResumeButtonClicked} />
          </div>
          {recordingStatusLabel ?
            <div className={styles.statusLabelContainer}>
              <Label id="RecordingStatusLabel" className={styles.statusLabel}>{recordingStatusLabel}</Label>
            </div> : null}
          {isEnabled ?
            <div className={styles.buttonContainer}>
              <AppButton id={'StopRecordingButton'} disabled={isRecordingCompleted} type={'AppButtonProps'} text={stopRecordingButtonLabel} onExecute={this._onStopRecordingClicked} />
            </div> : null}
        </React.Fragment>
          : <Spinner type={SpinnerType.large} />}
      </div>
    );
  }

  private StartRecordingTimer() {
    this.intervalID = window.setInterval(
      () => {
        this.setState({ recordingTime: this.state.recordingTime + 1 })
      },
      1000);
  }

  private StopRecordingTimer() {
    window.clearInterval(this.intervalID!);
  }

  private _onPauseResumeButtonClicked = async (): Promise<void> => {
    if (!this.props.isEnabled)
      return;

    const { isPaused } = this.state;

    if (this.props.onRecordingStatusChange) {
      this.props.onRecordingStatusChange(!isPaused);
    }

    if (!isPaused) {
      this.StopRecordingTimer();
    } else {
      this.StartRecordingTimer();
    }

    this.setState({ isPaused: !isPaused });
  };

  private _onStopRecordingClicked = (): void => {
    this.setState({ isRecordingCompleted: true });
    this.props.onRecordingStop();
  };
}